var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValetSoap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "valet-soap_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#valet-soap_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 8.333H7.472L3.445 20v15h3.888v-3.445h22.222V35h3.89V21.167h-2.778v7.61H6.222v-8.61H20v-2.778H7.305l2.112-6.278H20V8.333Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.192 26.153a2.332 2.332 0 0 1-1.692.68 2.263 2.263 0 0 1-1.653-.673c-.454-.45-.68-1.005-.68-1.667 0-.661.224-1.224.673-1.687.45-.463 1.005-.695 1.667-.695.661 0 1.224.232 1.687.697.463.464.695 1.028.695 1.692 0 .648-.232 1.199-.697 1.653ZM28.053 26.153a2.332 2.332 0 0 1-1.692.68c-.648 0-1.2-.224-1.653-.673-.453-.45-.68-1.005-.68-1.667 0-.661.224-1.224.673-1.687.45-.463 1.005-.695 1.666-.695.662 0 1.225.232 1.688.697.463.464.695 1.028.695 1.692 0 .648-.232 1.199-.697 1.653ZM21.77 16.337a2.536 2.536 0 0 0 1.866.774 2.55 2.55 0 0 0 1.868-.77 2.537 2.537 0 0 0 .773-1.866c0-.73-.256-1.352-.77-1.868a2.536 2.536 0 0 0-1.865-.774 2.55 2.55 0 0 0-1.869.771A2.537 2.537 0 0 0 21 14.47c0 .729.257 1.352.77 1.867ZM30.23 16.213a2.936 2.936 0 0 0 2.156.898c.841 0 1.561-.298 2.16-.896a2.937 2.937 0 0 0 .898-2.157c0-.84-.298-1.56-.896-2.16A2.936 2.936 0 0 0 32.391 11c-.84 0-1.56.299-2.16.896a2.937 2.937 0 0 0-.898 2.157c0 .841.299 1.561.896 2.16ZM24.98 9.795c.43.433.954.65 1.572.65a2.15 2.15 0 0 0 1.576-.646c.433-.43.65-.955.65-1.574 0-.618-.216-1.143-.646-1.576A2.135 2.135 0 0 0 26.559 6a2.15 2.15 0 0 0-1.576.646c-.433.43-.65.955-.65 1.573s.216 1.144.646 1.576Z"
}))));
export default SvgValetSoap;